import LazyLoadImg from "components/LazyLoadImg";
import { decodeHtmlEntities } from "constant/htmlEntities";
import { RouteName } from "constant/routeNames";
import { FaCrown } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { setLiveTVSuccess, setVideoStart } from "redux/VideoPlayerRedux";
import { ContentType } from "services/subscription/types";
import { convertFromGetAllChannels } from "utils/convertLiveTVData";
import { usePremiumAccess } from "hooks/usePremiumAccess";
import PremiumContentModal from "components/PremiumContentModal";

interface PackageResponse {
  id: number;
  entitlement_id: string;
  title: string;
  price: string;
  thumbnail: string;
  created_at: string;
  description: string;
  is_subscribed: boolean;
  role_id: number;
  slug: string;
}

export const ChannelCard = ({ data, img, is_creator }: any) => {
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const { isModalOpen, setIsModalOpen, checkAccess } = usePremiumAccess();

  const isPremiumContent = data?.plan_id === 2;

  const channelClicked = async () => {
    const access = await checkAccess({
      contentType: ContentType.TV_CHANNELS,
      id: data?.id,
      isPremiumContent,
      isCreator: is_creator,
    });
    if (!access) return;

    let video: any = convertFromGetAllChannels(data);
    await dispatch(setVideoStart());
    await dispatch(setLiveTVSuccess(video));
    navigate(RouteName.LiveTVPlayerLinkWithSlug.replace(":slug", data.slug));
  };

  const packageObject: PackageResponse = {
    id: data?.service_id || data?.id,
    entitlement_id: data?.entitlement_id,
    title: data?.name,
    price: data?.price,
    thumbnail: data?.thumbnail_url || img,
    created_at: data?.created_at || "",
    description: data?.description,
    is_subscribed: data?.is_Subscribed,
    role_id: data?.plan_id,
    slug: data?.slug,
  };

  return (
    <>
      <PremiumContentModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        isCreator={is_creator}
        packageObject={packageObject}
      />

      <div
        className="group relative block w-full cursor-pointer rounded-2xl p-4 text-center transition-all duration-300 ease-out hover:-translate-y-1 hover:bg-[#1c1b1b] hover:shadow-xl"
        onClick={channelClicked}
      >
        {/* Premium pill */}
        {isPremiumContent && (
          <div className="absolute left-1/2 top-1 z-20 flex -translate-x-1/2 items-center gap-1 rounded-full border border-white/15 bg-black/40 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide text-white shadow-lg backdrop-blur-md">
            <FaCrown className="text-[10px] text-[var(--red)]" />
            <span>Premium</span>
          </div>
        )}

        {/* Logo */}
        <div className="relative mx-auto flex aspect-square w-full max-w-[140px] items-center justify-center overflow-hidden rounded-full bg-[#363636] ring-1 ring-white/5 transition-all duration-300 group-hover:ring-2 group-hover:ring-[var(--red)]/50">
          <LazyLoadImg
            imgSrc={img}
            imgAlt={"Channel Icon"}
            wrapperProps={{
              style: {
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                display: "block",
              },
            }}
            className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-110"
            style={{ objectFit: "cover", width: "100%", height: "100%" }}
          />
        </div>

        <p className="mx-auto mt-3 line-clamp-2 w-[140px] text-sm font-medium text-white transition-colors group-hover:text-white">
          {decodeHtmlEntities(data.name)}
        </p>
      </div>
    </>
  );
};
